/* @flow */

export const SEND_SUPPORT_REQUEST = 'SEND_SUPPORT_REQUEST';
export const SEND_SUPPORT_FAILURE = 'SEND_SUPPORT_FAILURE';
export const SEND_SUPPORT_SUCCESS = 'SEND_SUPPORT_SUCCESS';
